import React from 'react';
import { useStore } from 'effector-react';
import { $libSearch } from '../stores/libState';
import ArticleSearchList from './ArticleSearchList';
import ArticleFetchList from './ArticleFetchList';

function ListArticle() {
  const query = useStore($libSearch);
  return query ? <ArticleSearchList /> : <ArticleFetchList />;
}

export default ListArticle;
